<template>
  <div class="page_wrapper">
    <p></p>
    <div class="box">
      <h3>Registry</h3>
      <div class= "zola" id="zola"> </div>
    </div>
  </div>
</template>

<script>
import postscribe from 'postscribe'

export default {
  mounted: function () {
    postscribe("#zola",`<a class="zola-registry-embed" href="www.zola.com/registry/maxwellandchristina2020" data-registry-key="maxwellandchristina2020">Our Zola Wedding Registry<\/a><script>!function(e,t,n){var s,a=e.getElementsByTagName(t)[0];e.getElementById(n)||(s=e.createElement(t),s.id=n,s.async=!0,s.src='https://widget.zola.com/js/widget.js',a.parentNode.insertBefore(s,a))}(document,'script','zola-wjs');<\/script>`)
  }
};

</script>

<style scoped>
</style>
